import {
  Component,
  OnDestroy,
  OnInit,
  ElementRef,
  AfterContentInit
} from '@angular/core';
import {
  DossierSituation
} from '../../api/plyca-dtos-v2';
import { ProcurementProjectDefinitionsDTO, ProcurementProjectStepsDefinitionDTO }
  from '../../api/plyca-dtos';
import {
  ActionResultDTO
} from '../../api/plyca-dtos-v2';
import { PlycaDataService } from '../../../services/plyca.service';
import { UserService } from '../../user.service';
import { FormService } from '../../components/forms/form.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { UIService } from '../../ui.service';
import { flatMap, catchError, finalize, groupBy } from 'rxjs/operators';
import { Observable, EMPTY, of } from 'rxjs';
import {
  HelpService,
  HelpType
} from '../../components/common/help/help.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { DossierModelsService } from '../dossierModels/DossierModels.service';
import { AppConfiguration } from '../../conf/app.configuration';
import { DialogService } from 'primeng-lts/dynamicdialog';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';

@Component({
  selector: 'newDossier',
  templateUrl: 'newDossier.template.html'
})
export class newDossierComponent extends BaseComponent implements OnInit, OnDestroy, AfterContentInit {
  loaded = false;

  // Listado de configuraciones definidas en ProcurementProjectDefinition.json
  stepsDefinition: ProcurementProjectDefinitionsDTO;
  // Configuracion de ficha utiliza
  stepDefinition: ProcurementProjectStepsDefinitionDTO;

  dossierPopupVisible = false;
  models: any[];

  isNewDossier: boolean = false;
  public groupedDef = new Map<string, any>();
  constructor(
    public plycaService: PlycaDataService,
    public userService: UserService,
    public dossierModelService: DossierModelsService,
    public formService: FormService,
    public helpService: HelpService,
    public activatedRoute: ActivatedRoute,
    public translate: TranslateService,
    public dialogService: DialogService,
    public uiService: UIService,
    public translationService: TranslateService,
    private headerActionsService: HeaderActionsService,
    private elem: ElementRef,
    private waitService: WaitLoadingService,
    protected appConfig: AppConfiguration,
    private router: Router,
    private plycaErrorHandler: PlycaErrorHandler
  ) {
    super();
  }

  private helpContextDossierModel() {
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.FE_SELECC_MODELO));
  }

  onCloseDossierModel() {
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.TIPO_FICHA));
  }

  ngOnInit(): void {
    this.waitService.startWaiting();
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.TIPO_FICHA));
    this.subscribe(this.loadStepsDefinition());
  }

  ngAfterContentInit(): void {
    this.setHeaderNuevo();
    this.setActionButtons();
  }

  ngOnDestroy(): void {
    this.headerActionsService.clearActions();
    super.ngOnDestroy();
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  private setHeaderNuevo(txt?: string) {
    // *****
    this.headerActionsService.setTaskDescription(
      this.elem,
      txt
        ? this.translate.instant('ProcurementProject.new') + ': ' + txt
        : this.translate.instant('ProcurementProject.new'),
      'fas fa-plus',
      true
    );
  }


  private setActionButtons() {
    this.waitService.startWaiting();
    this.headerActionsService.clearActions();
    this.headerActionsService.addDivider();
    this.subscribe(this.headerActionsService
      .addAction(
        'General.cancel',
        'fas fa-1-25x fa-times',
        'btn-outline-secondary',
        true
      ), () => {
        this.cancel();
      });
  }

  private loadStepsDefinition(): Observable<any> {
    console.log('loadStepsDefinition + waitservice');
    this.waitService.startWaiting();
    // 1. LEER CONFIGURACIONES
    return this.plycaService
      .getProcurementProjectSteps(
        'procurementProject/procurementProjectDefinition.json'
      ).pipe(flatMap(
        (stepsDef: ProcurementProjectDefinitionsDTO) => {
          console.log('resultado de getProcurementProjectSteps');
          this.stepsDefinition = stepsDef;
          console.log('2.1) SI ES UN EXPEDIENTE NUEVO');
          // Filtramos por perfil si la definicion los limita
          this.stepsDefinition.definitions = this.stepsDefinition.definitions
            .filter((def: ProcurementProjectStepsDefinitionDTO) => !def.profiles || this.userService.hasRoles(def.profiles))
          // this.selectStepMode = true;
          this.groupedDef.set('OTROS', []);

          if (this.stepsDefinition?.groups && this.stepsDefinition.groups.length > 0) {


            this.stepsDefinition.definitions.forEach(
              def => {

                if (def.group) {
                  let list = this.groupedDef.get(def.group)
                  if (!list) {
                    this.groupedDef.set(def.group, []);
                  }
                  this.groupedDef.get(def.group).push(def);

                } else {
                  let listOthers = this.groupedDef.get('OTROS')
                  if (!listOthers) {
                    this.groupedDef.set('OTROS', []);
                  }
                  this.groupedDef.get('OTROS').push(def);
                }

              }
            )

          }

          if (this.groupedDef.get('OTROS').length > 0) {
            this.stepsDefinition.groups.push({ name: this.translate.instant('ProcurementProject.definitions.groups.OTROS.name'), identifier: 'OTROS' })
          } else {
            this.groupedDef.delete('OTROS')
          }


          this.loaded = true;
          this.waitService.cancelWaiting();
          return EMPTY;
        }
      ),

        catchError(
          (err) => {

            this.plycaErrorHandler.showServerError(err);
            this.waitService.cancelWaiting();

            return of(true);
          })
      );
  }


  // ABRIR EL DIALOGO DE CREACION DE EXPEDIENTE (VACIO O UTILIZANDO UN MODELO)
  showCreateDossierPopup(stepDefinition: ProcurementProjectStepsDefinitionDTO) {
    this.stepDefinition = stepDefinition;
    this.subscribe(this.dossierModelService.getModels([DossierSituation.Normal]), result => {
      // TODO: FILTRAR MODELOS DEL TIPO DE EXPEDIENTE SELECCIONADO
      if (result) {
        this.models = result.content.filter(project => project.formId === stepDefinition.identifier);

        if (this.models && this.models.length > 0) {
          // Cuando se pulsa en iniciar expediente y hay modelos, se muestra la modal de selcción de modelos
          // y se carga el modelo en otro sitio
          this.helpContextDossierModel();
          this.dossierPopupVisible = true;
        } else {
          // Si se pulsa en iniciar expediente y no hay modelos, se carga la definición de la ficha correspondiente
          this.models = [];
          this.goToProcurementProject(stepDefinition);
        }
      } else {
        // No hay modelos
        this.goToProcurementProject(stepDefinition);
      }
    });
  }


  goToProcurementProject(stepDefinition: ProcurementProjectStepsDefinitionDTO, dossierId?: string) {
    console.log('INICIANDO EXPEDIENTE DEL TIPO', stepDefinition);
    let ruta = stepDefinition.route;
    if (!ruta) {
      ruta = 'procurementProject/'
    } else if (!ruta.endsWith('/')) {
      ruta += '/';
    }
    if (dossierId) {
      ruta += dossierId;
    }
    this.router.navigate([ruta],
      {
        // queryParams: { formid: stepDefinition.identifier, isModel: 'false' }
        queryParams: { formid: stepDefinition.identifier, formUUID: stepDefinition.formUUID, isModel: 'false' }
      });
  }

  cancel() {
    // TODO: GESTIONAR CANCEL
  }

  cancelCreateDossierPopup() {
    this.stepDefinition = undefined;
    this.models = [];
    this.dossierPopupVisible = true;
  }

  private setHeaderNuevoModelo(txt?: string) {
    // *****
    this.headerActionsService.setTaskDescription(
      this.elem,
      txt
        ? this.translate.instant('ProcurementProject.new') + ' desde modelo ' + txt
        : this.translate.instant('ProcurementProject.new'),
      'fas fa-plus',
      true
    );

  }
  createDossierFromModel(model: any) { // mierda
    this.waitService.startWaiting();
    this.subscribe(this.dossierModelService
      .createDossierFromModel(model).pipe(finalize(() => {

        this.waitService.cancelWaiting();
      })), (action: ActionResultDTO) => {
        console.log(
          'EXPEDIENTE CREADO A PARTIR DEL MODEL: ',
          model.identifier,
          action
        );

        if (action.objectResult) {
          let dossierId = action.objectResult.identifier;
          this.uiService.showSuccess(this.translate.instant('GenericDossier.created', { identifier: dossierId }),
            this.translate.instant('General.info'),
            'success');
          console.log('Entrando a editar project', dossierId);
          this.goToProcurementProject(this.stepDefinition, dossierId);

          // this.subscribe(this.loadStepsDefinition().pipe(finalize(() => {

          //   this.setHeaderNuevoModelo(this.stepDefinition.name);
          //   // *****

          //   this.subscribe(this.form.getCompleted(), (ok) => {
          //     if (ok) {
          //       this.waitService.cancelWaiting();
          //     }
          //   }
          //   )
          //   this.uiService.showSuccess(this.translate.instant('GenericDossier.created', {
          //     identifier: this.dossierId
          //   })
          //     ,
          //     this.translate.instant('General.info'),
          //     'success'
          //   );
          // })));
        }
      });
  }


}